import { NMAWindow } from "./nma-window";

declare const window: NMAWindow;

export interface ShareData {
  /* title: title of share - "Share With" */
  title: string;
  /* text: text that will be shared */
  text: string;
  /* url: url that will be shared */
  url: string;
}

export interface ShareProps {
  /* catalogEntryId: catalogEntryId for item to use in url */
  catalogEntryId: number;
  /* productName: name of product */
  productName: string;
  /* productImageUrl: url for product */
  productImageUrl: string;
  /* shareData: data object to share for mWeb/iOS */
  shareData: ShareData;
}

export function notifyNmaOfShare({
  catalogEntryId,
  productName,
  productImageUrl,
  shareData,
}: ShareProps) {
  const androidBridge = window?.WebShareBridge;
  try {
    // iOS case
    if (navigator.canShare && navigator.canShare(shareData)) {
      void navigator.share(shareData);
    }
    // Android case
    else if (androidBridge) {
      androidBridge.share(
        catalogEntryId,
        "Share With",
        productName,
        productImageUrl
      );
    }
    // Bridges not present, log for observability
    else {
      console.error(
        "notifyNmaOfShare() called but bridge not present. Android bridge:",
        androidBridge
      );
    }
  } catch (e) {
    console.error(
      "notifyNmaOfShare() called but an error occurred.",
      e,
      "Android bridge:",
      androidBridge
    );
  }
}
